import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { StateViewConfig } from '~/api/services/types'

export type { StateViewConfig }

export interface StateViewConfigsService {
  getStateViewConfigs: (viewKey: string, assetTypeId: string) => Promise<StateViewConfig>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): StateViewConfigsService => {
  return {
    getStateViewConfigs: async (viewKey: string, assetTypeId: string) => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.STATE_VIEW_CONFIGS_GET, {
        params: { view_key: viewKey },
        queryParams: { asset_type_ids: assetTypeId }
      })
      return await client<StateViewConfig>(url, { method, headers, body })
    }
  }
}
